import { ReactNode } from "react";
import { UserRole } from "../../types/role";
import { useSelector } from "../../redux/store";
import { useSimplePopups } from "../../providers/SimplePopups/SimplePopupProvider";
import { SimplePopupType } from "../../providers/SimplePopups/data";
import { Navigate, useNavigate } from "react-router";
import FullScreenLoading from "../loading/FullScreenLoading";

interface IProps {
  children: ReactNode;
  accessDeniedPath?: string;
  permission: UserRole;
}

export const UserPermissionWrapper = ({
  accessDeniedPath,
  children,
  permission,
}: IProps) => {
  const { isLoading, user, logged } = useSelector(({ auth }) => auth);

  if (isLoading) {
    return <FullScreenLoading />;
  }

  if (user && logged && !isLoading) {
    if (user.function === permission || user.function === UserRole.Root) {
      return <>{children}</>;
    }

    return <Navigate to={accessDeniedPath ?? "/"} />;
  }

  return <Navigate to="/login" />;
};

type TWrapWithUserPermissionParams = {
  permission: UserRole;
  accessDeniedPath?: string;
};

export const wrapWithUserPermission = (
  component: ReactNode,
  { accessDeniedPath, permission }: TWrapWithUserPermissionParams
) => {
  return (
    <UserPermissionWrapper
      permission={permission}
      accessDeniedPath={accessDeniedPath}
    >
      {component}
    </UserPermissionWrapper>
  );
};

export default UserPermissionWrapper;
